import React, { forwardRef } from "react";
import "./FloatingField.css";

// A text input (or textarea) whose label sits inside the box and floats up
// once the field is focused or filled. `placeholder` becomes a hint shown
// only while typing, so it never overlaps the label.
const FloatingField = forwardRef(function FloatingField(
  { id, label, multiline = false, placeholder, ...inputProps },
  ref
) {
  const Control = multiline ? "textarea" : "input";
  return (
    <div className={`float-field${multiline ? " float-field-multiline" : ""}`}>
      {/* The CSS needs a placeholder to detect "empty"; a space stays invisible. */}
      <Control ref={ref} id={id} placeholder={placeholder || " "} {...inputProps} />
      <label htmlFor={id}>{label}</label>
    </div>
  );
});

export default FloatingField;
